export const ACHIEVEMENT_TASK_TYPE = Object.freeze({
    STEP: 'steps',
    PERCENTAGE: 'percentage',
});
